/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type { ErrorType } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type { LanguageDto } from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getUmbracoDeliveryApiV2Localization = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<LanguageDto[]>(
		{ url: `/umbraco/delivery/api/v2/localization`, method: "GET", signal },
		options,
	);
};

export const getGetUmbracoDeliveryApiV2LocalizationQueryKey = () => {
	return [`/umbraco/delivery/api/v2/localization`] as const;
};

export const getGetUmbracoDeliveryApiV2LocalizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoDeliveryApiV2LocalizationQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2Localization(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2LocalizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>
>;
export type GetUmbracoDeliveryApiV2LocalizationQueryError = ErrorType<void>;

export function useGetUmbracoDeliveryApiV2Localization<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2Localization<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2Localization<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2Localization<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2LocalizationQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoDeliveryApiV2LocalizationSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoDeliveryApiV2LocalizationQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2Localization(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2LocalizationSuspenseQueryResult =
	NonNullable<Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>>;
export type GetUmbracoDeliveryApiV2LocalizationSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2LocalizationSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2LocalizationSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2LocalizationSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2LocalizationSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
	TError = ErrorType<void>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Localization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2LocalizationSuspenseQueryOptions(options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}
